import React from 'react';
import { Box } from '@mui/material';
import { CustomTooltip } from './tooltip_component';
import { NavigationIcons } from '../../enums/general.names.enum';
import invoicemanagement from '../../Assets/AlertIcon/invoicemanagement.svg';

export const InvoiceManagementLeftBarPath = (props) => {
  const { selectedIcon, activeItemStyle, iconStyle, handleIconClick, hideTooltip = false } = props;

  const iconContent = (
    <Box
      style={selectedIcon === NavigationIcons.INVOICE_MANAGEMENT ? activeItemStyle : iconStyle}
      onClick={() => handleIconClick(NavigationIcons.INVOICE_MANAGEMENT, 'Invoice Management')}
    >
      <img src={invoicemanagement} alt="Invoice Management" width="20" height="20" />
    </Box>
  );

  return (
    <>
      {hideTooltip ? (
        iconContent
      ) : (
        <CustomTooltip title="Invoice Management">{iconContent}</CustomTooltip>
      )}
    </>
  );
};
